import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/layout/Header";
import Home from "./components/home/Home";
import Contact from "./components/contact/Contact";
import Footer from "./components/layout/Footer";
import CookieConsent from "./components/layout/CookieConsent";
import { ThemeProvider } from "./context/ThemeContext";
import useScrollToTop from "./hooks/useScrollToTop";
import "./styles/index.scss";


import PrivacyPolicy from './components/privacy/PrivacyPolicy';
import Terms from './components/terms/Terms';
import News from './components/news/News';

// Create a wrapper component that uses the hook
const ScrollToTopWrapper = ({ children }) => {
  useScrollToTop();
  return children;
};

function App() {
  return (
    <ThemeProvider>
      <Router>
        <ScrollToTopWrapper>
          <div className="App">
            <Header />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/contact" element={<Contact />} />

              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/news" element={<News />} />
            </Routes>
            <Footer />
            <CookieConsent />
          </div>
        </ScrollToTopWrapper>
      </Router>
    </ThemeProvider>
  );
}

export default App;
